import type { PackageSettingsMatch, ResolveMap, ResolveMapEntry } from '@ms-cloudpack/common-types';
import { checkMatch } from '@ms-cloudpack/config';
import { bold, bulletedList, formatPackageName, plural } from '@ms-cloudpack/task-reporter';

/**
 * Find packages in the resolve map that match the requested names and versions.
 */
export function getFilteredPackages(resolveMap: ResolveMap, match: PackageSettingsMatch[]): string[] {
  // Find matching packages in the resolve map
  const resolveMapEntries: ResolveMapEntry[] = [];

  for (const entry of Object.values(resolveMap)) {
    if (checkMatch({ name: entry.name, version: entry.version, match })) {
      resolveMapEntries.push(entry);
    }
    for (const scopedEntry of Object.values(entry.scopedVersions || {})) {
      if (checkMatch({ name: scopedEntry.name, version: scopedEntry.version, match })) {
        resolveMapEntries.push(scopedEntry);
      }
    }
  }

  const matchArgsString = match
    .map((m) => `"${bold(typeof m === 'object' ? `${m.name}@${m.version || '*'}` : m || '*')}"`)
    .join(', ');

  if (!resolveMapEntries.length) {
    console.error(`No packages found matching ${matchArgsString}`);
  } else {
    console.log(
      `\nFound ${plural(resolveMapEntries.length, 'package')} matching ${matchArgsString}:\n` +
        bulletedList(resolveMapEntries.map((entry) => `${formatPackageName(entry)}: ${entry.path}`)),
    );
  }

  return resolveMapEntries.map((entry) => entry.path);
}
